"use client";

import dynamic from "next/dynamic";
import MemberSubscribeForm from "../_components/member-subscribe/MemberSubscribeForm";
import { ZeffyIframe } from "../_components/ZeffyIframe";
import { tagada } from "../global-fonts";

const PDFViewer = dynamic(() => import("../_components/PDFViewer"), {
  ssr: false,
});

const annualReportUrl2025 = `https://rg-website-content.sfo2.digitaloceanspaces.com/rg_impact_report_2025.pdf`;

export default function JoinUs() {
  return (
    <main
      className={`text-sand
      bg-burgundy
      z-0
      `}
    >
      <h1
        className={`
        pt-16
        text-fluid-md
        lg:text-fluid-lg
        text-center
        ${tagada.className}
        `}
      >
        Make a Donation to Revolutionary Grains
      </h1>
      <div
        className={`
          pt-8
          flex 
          flex-col
          lg:flex-row-reverse
          pl-12
          pr-12
          lg:pl-24
          lg:pr-24
      `}
      >
        <section
          className={`
          lg:w-[50%]`}
        >
          <ZeffyIframe
            // @ts-expect-error Required for Zeffy embed to function as intended
            allowpaymentrequest="true"
            title='Donation form powered by Zeffy'
            src='https://www.zeffy.com/embed/donation-form/beec7c87-17db-4f11-bf1f-f05ba448fe2a'
            className={`
              w-[100%]
              m-auto
              rounded-[3rem]
              h-[80vh]
              mb-16
              lg:w-[100%]
              lg:h-[60vw]
              lg:mb-0
            `}
          />
        </section>
        <section
          className={`
          bg-earth
          p-8
          rounded-[3rem]
          font-[500]
          lg:w-[50%]
          ml-0
          ml-0
          lg:mr-8
        `}
        >
          <h2
            className={`${tagada.className}
            text-fluid-md
            pb-8`}
          >
            Why join us?
          </h2>
          <p
            className={`text-fluid-sm
            pb-8
            `}
          >
            The corporate industries dominating our food systems are BIG. This
            can be overwhelming, but building strong community around the goals
            of growing, tending, and sharing the gifts of flavorful food, can
            remind us that nourishment is an act of love.
          </p>
          <p
            className={`text-fluid-sm
            `}
          >
            We need this nourishing love now, more than ever. This is why we
            invite you to our table, beyond the market shelves and into the
            sensuous embrace of food, story, and connection. When you become a
            part of our movement, you become a part of our community.
            Participating in our in-person events, slowing down to witness our
            exhibition pieces on this website, and tasting the products we offer
            strengthens the impact of Revolutionary Grains. Donating,
            volunteering, and sharing our efforts, enables us to continue
            hosting these events, creating stories, and collaborating with
            heritage food protectors around the globe.
          </p>
        </section>
      </div>
      <section
        className={`
          text-center
          relative
          pt-48
          z-1
        `}
      >
        <h2
          className={`
              ${tagada.className}
              text-center
              text-fluid-lg
              mb-4
              bg-sky
              ml-auto
              mr-auto
              w-[60%]
              text-burgundy
              rounded-[1rem]
              z-[200]
            `}
        >
          Subscribe to our newsletter
        </h2>
        <MemberSubscribeForm />
      </section>
      <div
        className={`
            relative
            rounded-[8rem]
            bg-earth
            z-0
            top-[-28rem]
            mb-[-24rem]
            md:top-[-24rem]
            lg:top-[-32rem]
            lg:mb-[-24rem]
          `}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          className={`
              relative
              rounded-[8rem]
              object-cover
              h-[32rem]
              lg:h-[40rem]
              w-full
              opacity-30
          `}
        >
          <source src="/videos/planting-seeds.mp4" type="video/mp4" />
        </video>
      </div>
      <section
        className={`
            flex
            flex-col
            items-center`}
      >
        <h2
          className={`
            ${tagada.className}
            text-fluid-md
            lg:text-fluid-lg
            pb-8
            text-center`}
        >
          Annual Reports
        </h2>
        <PDFViewer url={annualReportUrl2025} expectedTotalPages={21} backgroundColor="#f8f2eaff"/>
      </section>
    </main>
  );
}
